import { render, staticRenderFns } from "./Program.vue?vue&type=template&id=08094f61&scoped=true&"
import script from "./Program.vue?vue&type=script&lang=js&"
export * from "./Program.vue?vue&type=script&lang=js&"
import style0 from "./Program.vue?vue&type=style&index=0&id=08094f61&prod&lang=scss&"
import style1 from "./Program.vue?vue&type=style&index=1&id=08094f61&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08094f61",
  null
  
)

export default component.exports